var api = require("!../../../../../node_modules/.pnpm/style-loader@2.0.0_webpack@5.106.2_@swc+core@1.15.30_@swc+helpers@0.5.21__esbuild@0.27.7_/node_modules/style-loader/dist/runtime/injectStylesIntoStyleTag.js");
            var content = require("!!../../../../../node_modules/.pnpm/css-loader@5.2.7_webpack@5.106.2_@swc+core@1.15.30_@swc+helpers@0.5.21__esbuild@0.27.7_/node_modules/css-loader/dist/cjs.js??ruleSet[1].rules[1].use[1]!./inter.css");

            content = content.__esModule ? content.default : content;

var options = {};

options.insert = "head";
options.singleton = false;

var update = api(content, options);



module.exports = content.locals || {};